import { useState, useEffect } from "react";
import useAuthStore from "../../../stores/Auth/AuthStore";
import { getUserOrderHistory } from "../../../services/Profile/ProfileService";
import { calculateShippingCost } from "../../../services/GHN/GHNService";

export const useOrderHistory = () => {
  const { user, isAuthenticated } = useAuthStore();
  const [isLoading, setIsLoading] = useState(false);
  const [orderHistory, setOrderHistory] = useState([]);
  const [expandedShipping, setExpandedShipping] = useState({});
  const [expandedItems, setExpandedItems] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  // Load order history with pagination
  useEffect(() => {
    const loadOrderHistory = async () => {
      if (!user?.id) return;
      let shipCost = 0
      let res = await calculateShippingCost();
      if (res.success) {
        shipCost = res.shipping_cost
      }

      setIsLoading(true);
      try {
        const apiOrders = await getUserOrderHistory(user.id, currentPage);
        if (apiOrders && apiOrders.orders && apiOrders.orders.length > 0) {
          // let OrdersHistoryList = apiOrders
          // setOrderHistory(apiOrders);
          const updatedOrders = apiOrders.orders.map((order) => {
            if (order.payment.shipping_cost === 0) {
              return {
                ...order,
                payment: {
                  ...order.payment,
                  shipping_cost: shipCost,
                  total_amount: order.payment.total_amount + shipCost,
                },
              };
            }
            return order;
          });

          setOrderHistory({
            ...apiOrders,
            orders: updatedOrders,
          });
        } else {
          setOrderHistory({ orders: [], total_orders: 0, total_pages: 1 });
        }
      } catch (error) {
        console.error("Error loading order history:", error);
        setOrderHistory({ orders: [], total_orders: 0, total_pages: 1 });
      } finally {
        setIsLoading(false);
      }
    };

    if (isAuthenticated && user?.id) {
      loadOrderHistory();
    }
  }, [user?.id, isAuthenticated, currentPage]);
  
  const toggleShippingInfo = (orderId) => {
    setExpandedShipping((prev) => ({
      ...prev,
      [orderId]: !prev[orderId],
    }));
  };

  const toggleOrderItems = (orderId) => {
    setExpandedItems((prev) => ({
      ...prev,
      [orderId]: !prev[orderId],
    }));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    // Reset expanded states when changing page
    setExpandedShipping({});
    setExpandedItems({});
  };

  return {
    orderHistory,
    isLoading,
    currentPage,
    expandedShipping,
    expandedItems,
    toggleShippingInfo,
    toggleOrderItems,
    handlePageChange,
  };
};
